import axios from 'utils/axios'

export const post = (platform, token) => {
  const endpoint = `/mobile/${platform}/token`
  return axios.post(endpoint, { token })
}
